// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useContext} from 'react';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import cn from 'classnames';
import {toolip_img_url} from '../../../../hola/pub/ui/toolip_img_url';
import {Button} from '../../../../hola/pub/lib/button';
import Arrow_right from '../../../../hola/pub/img/hola2023/icons/24/arrow_right.svg';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import {Input} from '../../../../hola/pub/lib/input';
import {Textarea} from '../../../../hola/pub/lib/textarea';
import {Dynamic_heading, Title_header_select} from '../../../../shared/editor/title_header_select';
import {Lottie} from '../../../../shared/ui/lottie';

import styles from './use_case_page.module.less';

interface i_use_case_hero_props {
    title: string;
    title_tag: string;
    subtitle: string;
    img?: string;
    button_text?: string;
    button_url?: string;
    under_btn?: string;
}
interface i_use_case_hero_editor_props {
    value: i_use_case_hero_props;
    on_change: (v:i_use_case_hero_props)=>void
}

const render_content = content=>{
  if (React.isValidElement(content))
      return content;
  if (typeof content == 'string' && content.includes('\n'))
      return content.replace(/\n/g, '<br/>');
  return content;
};

export const Use_case_hero = (props: i_use_case_hero_props)=>{
    const {theme} = useContext(Settings_context);
    const {T, t} = use_translation_v({no_defaults: true});
    const {title, subtitle, img, button_text = 'Try Now',
        button_url = '/pricing', under_btn =
        '5 proxies for free | no credit card required'} = props;
    const image_src = img && img.startsWith('http') ? img
        : toolip_img_url(`use_cases/${img || 'default'}`);
    return <div className={cn(styles.hero, theme.container)}>
      <div className={styles.hero_box}>
        <div className={styles.hero_top}>
          <p className={cn(theme.mono12, styles.uptime)}>
            <Lottie autoplay loop width="20px" height="14px"
              src={toolip_img_url('animation/uptime.json')}/>
            <span>{t('uptime: ')} <b>99.9%</b></span>
          </p>
        </div>
        <div className={styles.main_title}>
        <Dynamic_heading className={theme.H2} tag={props.title_tag || 'h1'}>
          <T>{render_content(title)}</T>
        </Dynamic_heading>
        </div>
        <div className={styles.sub_title}>
          <p className={cn(theme.u1, theme.med, theme.color_n600)}>
            <T>{render_content(subtitle)}</T>
          </p>
        </div>
        <div className={styles.hero_button}>
          <Button size='lg' width={240} cls={styles.button} caption=
            {<Fragment><T>{button_text}</T><Arrow_right/></Fragment>}
            round={false} color='black' to={button_url} fit/>
          <p className={cn(theme.p4, theme.med, styles.button_text)}>
            {t(under_btn)}
          </p>
        </div>
      </div>
      <div className={styles.hero_img}>
        <img src={image_src} className={styles.img}/>
      </div>
    </div>;
};

export const Use_case_hero_editor = (props:i_use_case_hero_editor_props)=>{
  const {value, on_change} = props;
  return <div>
    <Textarea
      value={value?.title || ''}
      on_change={v=>on_change({...value, title: v})}
      placeholder={'Hero Title (Use Enter for line breaks)'}
    />
    <Title_header_select value={value.title_tag} on_select={v=>
      on_change({...value, title_tag: v})}/>
    <Textarea
      value={value?.subtitle || ''}
      on_change={v=>on_change({...value, subtitle: v})}
      placeholder={'Hero Subtitle (Use Enter for line breaks)'}
    />
    <Input
      value={value.img ||
        'https://cdn4.toolip.io/www/toolip/pub/img/use_cases/{img_name}.png'}
      on_change={v=>on_change({...value, img: v})}
      label={'Image Name'} placeholder=
        {'https://cdn4.toolip.io/www/toolip/pub/img/use_cases/{img_name}.png'}
    />
    <Input
      value={value.button_text || ''}
      on_change={v=>on_change({...value, button_text: v})}
      label={'Button Text'} placeholder={'Try Now'}
    />
    <Input
      value={value.button_url || ''}
      on_change={v=>on_change({...value, button_url: v})}
      label={'Button URL'} placeholder={'/pricing'}
    />
    <Input
      value={value?.under_btn}
      on_change={v=>on_change({...value, under_btn: v})}
      label={'Text Under Button'}
      placeholder={'5 proxies for free | no credit card required'}
    />
  </div>;
};
